import { render, staticRenderFns } from "./FactoryAccessDashboard.vue?vue&type=template&id=0ca11221&scoped=true"
import script from "./FactoryAccessDashboard.vue?vue&type=script&lang=js"
export * from "./FactoryAccessDashboard.vue?vue&type=script&lang=js"
import style0 from "./FactoryAccessDashboard.vue?vue&type=style&index=0&id=0ca11221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca11221",
  null
  
)

export default component.exports